(function () {
  'use strict';

  var SECTION_SELECTOR = '.wb-ts';
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initScrollText(section) {
    var textWrap = section.querySelector('[data-scroll-text]');
    if (!textWrap) return;

    if (prefersReduced) {
      textWrap.style.setProperty('--wb-ts-progress', '100%');
      return;
    }

    if (section._textScrollCleanup) {
      section._textScrollCleanup();
    }

    var triggerStartRaw = parseFloat(section.dataset.triggerStart) || 85;
    var triggerEndRaw = parseFloat(section.dataset.triggerEnd) || 40;
    var currentProgress = 0;
    var targetProgress = 0;
    var lerpFactor = 0.08;
    var rafId = null;
    var ticking = false;
    var isAnimating = false;

    function calculateTarget() {
      var rect = textWrap.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var startY = vh * (triggerStartRaw / 100);
      var endY = vh * (triggerEndRaw / 100);
      var distanceToCover = startY - (endY - rect.height);
      var progressPx = startY - rect.top;
      var rawPercentage = distanceToCover === 0 ? 100 : (progressPx / distanceToCover) * 100;

      targetProgress = Math.max(0, Math.min(100, rawPercentage));
      ticking = false;

      if (!isAnimating) {
        isAnimating = true;
        rafId = requestAnimationFrame(renderLoop);
      }
    }

    function renderLoop() {
      currentProgress += (targetProgress - currentProgress) * lerpFactor;

      if (Math.abs(targetProgress - currentProgress) < 0.1) {
        currentProgress = targetProgress;
        textWrap.style.setProperty('--wb-ts-progress', currentProgress.toFixed(2) + '%');
        isAnimating = false;
        rafId = null;
        return;
      }

      textWrap.style.setProperty('--wb-ts-progress', currentProgress.toFixed(2) + '%');
      rafId = requestAnimationFrame(renderLoop);
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(calculateTarget);
    }

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });

    calculateTarget();
    currentProgress = targetProgress;
    textWrap.style.setProperty('--wb-ts-progress', currentProgress.toFixed(2) + '%');

    section._textScrollCleanup = function () {
      window.removeEventListener('scroll', requestUpdate);
      window.removeEventListener('resize', requestUpdate);

      if (rafId) {
        cancelAnimationFrame(rafId);
      }

      section._textScrollCleanup = null;
    };
  }

  function initSection(root) {
    var sections = root.matches && root.matches(SECTION_SELECTOR) ? [root] : root.querySelectorAll(SECTION_SELECTOR);

    sections.forEach(function (section) {
      initScrollText(section);
    });
  }

  function init() {
    initSection(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initSection(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target.querySelector(SECTION_SELECTOR);

    if (section && section._textScrollCleanup) {
      section._textScrollCleanup();
    }
  });
})();